import { SliderConfig } from './BaseSlider';
import { HALF_THUMB_WIDTH, THUMB_WIDTH } from './constants';

export const calculateTickPositions = (containerWidth: number, numberOfTicks: number) => {
  if (containerWidth === 0 || numberOfTicks < 2) return [];

  const availableWidth = containerWidth - THUMB_WIDTH;
  return Array.from({ length: numberOfTicks }, (_, i) => {
    const percentage = numberOfTicks === 1 ? 0 : i / (numberOfTicks - 1);
    return percentage * availableWidth + HALF_THUMB_WIDTH;
  });
};

export const getThumbPosition = (containerWidth: number, percentValue: number) => {
  if (!containerWidth) return 0;
  const availableWidth = containerWidth - THUMB_WIDTH;
  return percentValue * availableWidth + HALF_THUMB_WIDTH;
};

export const getNotch = (notches: number[], index: number): number => {
  if (index < 0 || index >= notches.length || notches[index] === undefined) {
    throw new Error(`Notch index ${index} out of bounds`);
  }
  return notches[index];
};

export const getSliderValueFromPct = (config: SliderConfig, pct: number) => {
  // Calculate raw value based on percentage
  const rawValue = config.min + (config.max - config.min) * pct;

  // Snap to nearest step (same logic as native range input)
  const steps = Math.round((rawValue - config.min) / config.step);
  const snappedValue = config.min + steps * config.step;

  // Clamp to min/max bounds
  const clampedValue = Math.min(config.max, Math.max(config.min, snappedValue));

  const newValue = config.denormalizeValue(clampedValue);

  return newValue;
};
